const deletedOrderStyle = {
    textDecorationLine      :'line-through',
    textDecorationColor     : 'red',
    textDecorationThickness : '0.3rem'
};

export default deletedOrderStyle;